import { CameraData } from "@web/types/CameraData";
import styles from "./css/CameraDetails.module.css";
import { getCameraDataForDisplay } from "@web/utils/camera/getCameraDataForDisplay";
import { CameraDetail } from "@web/components/camera/CameraDetail";

export function CameraDetails({
  cameraData,
  isSingleColumn,
}: {
  cameraData: CameraData;
  isSingleColumn: boolean;
}) {
  const dataForDisplay = getCameraDataForDisplay(cameraData);
  const column1 = (
    <>
      <CameraDetail labelAndValue={dataForDisplay["Market"]} />
      <CameraDetail
        labelAndValue={dataForDisplay["Fully Mechanical or Electric"]}
      />
      <CameraDetail labelAndValue={dataForDisplay["Shutter Speed"]} />
      <CameraDetail labelAndValue={dataForDisplay["Aperture Priority Mode"]} />
      <CameraDetail labelAndValue={dataForDisplay["Weight"]} />
      <CameraDetail labelAndValue={dataForDisplay["ASA"]} />
      <CameraDetail labelAndValue={dataForDisplay["Battery"]} />
      <CameraDetail labelAndValue={dataForDisplay["Bulb Mode"]} />
    </>
  );

  const column2 = (
    <>
      <CameraDetail labelAndValue={dataForDisplay["Average Price"]} />
      <CameraDetail labelAndValue={dataForDisplay["Advanced Features"]} />
      <CameraDetail labelAndValue={dataForDisplay["Additional Information"]} />
      {dataForDisplay["Common Issues"].value && (
        <CameraDetail labelAndValue={dataForDisplay["Common Issues"]} />
      )}
    </>
  );

  if (isSingleColumn) {
    return (
      <div className={styles.cameraDetailsColumn}>
        {column1}
        {column2}
      </div>
    );
  }

  return (
    <div className={styles.cameraDetailsColumns}>
      <div className={styles.cameraDetailsColumn}>{column1}</div>
      <div className={styles.cameraDetailsColumn}>{column2}</div>
    </div>
  );
}
